export default __webpack_public_path__ + "static/media/under_construction.1a59ea7c.png";